export default __webpack_public_path__ + "static/media/mg.356d0fe3.png";